import React, { useEffect } from 'react';
import './barrel.style.scss';
import { ITankState } from '../../interfaces/applicant.interface';
import { useTranslation } from 'react-i18next';
import { OIL_PRODUCT_COLORS } from '../../constants/main.constants';

interface IProps {
  tank: ITankState;
}

const Barrel: React.FC<IProps> = ({ tank }) => {
  const { t } = useTranslation();

  return (
    <div className="barrel">
      <div className="barrel__type">{tank.oilProductType}</div>
      <div className="barrel__volume">
        {tank.volume} {tank.volumeUnitType && t(`enum.volumeUnitShort.${tank.volumeUnitType}`)}
      </div>
      <div
        className="barrel__color"
        style={{
          backgroundColor:
            (tank.oilProductType && OIL_PRODUCT_COLORS[tank.oilProductType]) ?? '#808080',
        }}
      ></div>

      <div className="barrel__top"></div>
      <div className="barrel__body">
        <div className="barrel__ring"></div>
        <div className="barrel__ring"></div>
        <div className="barrel__ring"></div>
      </div>
      <div className="barrel__bottom"></div>
    </div>
  );
};

export default Barrel;
